import React from 'react';
import {
  darkTheme,
  lightTheme,
  ThemeProvider,
  useLocalStorage,
} from '@ihsm/ui-shared';

export const StoredThemeProvider: React.FC = ({ children }) => {
  const [storedTheme, setStoredTheme] = useLocalStorage({
    key: 'ui-theme',
    initial: 'dark',
  });

  return (
    <ThemeProvider
      initialTheme={storedTheme}
      onChange={(theme) => setStoredTheme(theme)}
      themes={[lightTheme, darkTheme]}
    >
      {children}
    </ThemeProvider>
  );
};
